import React from 'react';
import { useTranslation } from 'react-i18next';
import { SubmitFormValues } from '../../redux/types';
import FieldFormPopup from '../FieldFormPopup';
import type {
  FieldFormPopupProps,
  FieldFormPopupState,
} from '../FieldFormPopup/types';
import LicenseForm from '../../common/LicenseForm';

const LicenseFormPopup: React.FC<
  FieldFormPopupProps & FieldFormPopupState<SubmitFormValues['license']>
> = ({ currentValue, setValue, ...props }) => {
  const { t } = useTranslation();
  return (
    <FieldFormPopup
      {...props}
      heading={t('deviationSubmit.form.license.modal.heading')}
    >
      <LicenseForm
        currentValue={currentValue}
        setValue={setValue}
        subheading={t('deviationSubmit.form.license.modal.subheading')}
      />
    </FieldFormPopup>
  );
};
LicenseFormPopup.displayName = 'LicenseFormPopup';

export default LicenseFormPopup;
